module.exports = __webpack_public_path__ + "static/media/user-plus.2713003f.svg";